import cn from 'classnames';
import styles from './Callouts.module.scss';
export function getVariantClass() {
    let variant = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'card';
    return cn(styles.callout, variant === 'row' && styles.calloutRow);
}
export function getVariantSkin() {
    let variant = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'card';
    return variant === 'row' ? 'transparent' : undefined;
}
